import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CarIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CarIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M5.05057 10.613L4.98874 9.38891C4.97638 9.11998 4.82492 8.87886 4.58999 8.74594L3.35351 8.0597L2.54053 9.52492L4.99184 10.8881C5.0382 10.8078 5.05985 10.7119 5.05366 10.6161"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.0305 10.613L20.0923 9.38891C20.1047 9.11998 20.2561 8.87886 20.4911 8.74594L21.7276 8.0597L22.5405 9.52492L20.0892 10.8881C20.0429 10.8078 20.0212 10.7119 20.0274 10.6161"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.5433 12.6439C8.5186 12.6439 5.04411 10.9098 4.98846 10.885V18.9438C4.98846 19.2776 5.2605 19.5496 5.59434 19.5496H7.29758C7.45832 19.5496 7.61289 19.4847 7.72726 19.3703L8.87409 18.2142C8.98846 18.0999 9.14303 18.0349 9.30377 18.0349H15.7829C15.9436 18.0349 16.0982 18.0999 16.2126 18.2142L17.3594 19.3703C17.4738 19.4847 17.6283 19.5496 17.7891 19.5496H19.4923C19.8262 19.5496 20.0982 19.2776 20.0982 18.9438V10.885C20.0425 10.9098 16.5711 12.6439 12.5433 12.6439Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.0982 10.885L17.99 5.52153C17.8045 4.87857 17.2203 4.4458 16.5557 4.4458H8.53097C7.87255 4.4458 7.28831 4.87857 7.09666 5.52153L4.98846 10.885C5.04411 10.8603 8.51551 9.12586 12.5433 9.12586C16.5711 9.12586 20.0425 10.8603 20.0982 10.885Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CarIcon;
